export const PROJECTS = {
  BASE: '/projects',
};
